import type { Epic } from 'Flux/index.js'
import { catchError, filter, map, switchMap } from 'rxjs/operators'
import { of } from 'rxjs'
import { invitationSlice } from '../../Slice/Invitation/InvitationSlice.js'

export const GetInviteByIdEpic: Epic = (action$, state$, { InviteRepository }) => {
  return action$.pipe(
    filter(invitationSlice.actions.getInviteByIdRequest.match),
    switchMap((action) => {
      return InviteRepository.getInviteById(action.payload.inviteId).pipe(
        map((invite) => invitationSlice.actions.getInviteByIdRequestSuccess(invite)),
        catchError((error) => of(invitationSlice.actions.getInviteByIdRequestFailure({ error })))
      )
    })
  )
}
